export const getFilterUrlFromForm = (form: HTMLFormElement) => {
	// Получаем все данные из формы
	const formData = Array.from(new FormData(form))

	// Сохраняем код категории в фильтре
	const listSectionCode = document.querySelector('input[name="LIST_SECTION_CODE"]')?.getAttribute('value')

	// Создаем объект фильтра
	const filterObj = formData.reduce((acc, [name, value]) => {
		// Игнорируем пустые значения
		if (value === '') return acc

		if (!acc[name]) {
			acc[name] = {}
			acc[name].type = name === `PRICE` ? `><` : `=`
			acc[name].value = [value === 'on' ? 'Да' : value]
		} else {
			acc[name].value = [...acc[name].value, value]
		}

		return acc
	}, {})

	// Если есть код категории и он не добавлен в фильтр, добавляем его
	if (listSectionCode && !filterObj['LIST_SECTION_CODE']) {
		filterObj['LIST_SECTION_CODE'] = {
			type: '=',
			value: [listSectionCode]
		}
	}

	return JSON.stringify(filterObj)
}
